import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  p {
    font-size: 16px;
    font-weight: 600;
  }
`;
